import React, { Fragment } from 'react'
import NavigationMobile from '../navigationMobile/navigationMobile'
import BackToTop from '../backToTop/backToTop'
import './theme.css'
import './app.css'
import Seo from '../seo/seo'
import styles from './app.module.css'

const App = props => {
  const getChildrenWithProps = () => {
    return React.cloneElement(props.children, props)
  }

  const getPath = () =>
    props.seo && props.seo.path ? props.seo.path : undefined
  const getDescription = () =>
    props.seo && props.seo.description ? props.seo.description : undefined
  const getTitle = () =>
    props.seo && props.seo.title ? props.seo.title : undefined
  const getImage = () =>
    props.seo && props.seo.image ? props.seo.image : undefined

  return (
    <Fragment>
      <Seo
        path={getPath()}
        title={getTitle()}
        description={getDescription()}
        image={getImage()}
      />
      <NavigationMobile
        pageWrapId={'app'}
        outerContainerId={'App'}
        items={props.navigation}
      />
      <div id="app" className={styles.app}>
        {getChildrenWithProps()}
      </div>
      <BackToTop />
    </Fragment>
  )
}

export default App
